@if (isStacked) {
  <div class="flex flex-col gap-2 p-2">
    @if (showAccount) {
      <gb-header-account-menu
        mode="drawer"
        [dashboardUrl]="dashboardUrl"
        [showUnauthenticatedCta]="false"
        (menuAction)="onMenuAction()"
      ></gb-header-account-menu>
    }

    @if (isBrowser && !isAuthenticated && !(user$ | async)) {
      <ui-button variant="ghost" [block]="true" (buttonClick)="goToLogin()">
        {{ signInLabel }}
      </ui-button>
    }

    <ui-button
      variant="primary"
      [outline]="true"
      [block]="true"
      ariaLabel="Create a fundraising page"
      (buttonClick)="fundraise()"
    >
      Fundraise
    </ui-button>

    <ui-button
      variant="primary"
      [block]="true"
      [routerLink]="AppRoutes.checkout.root()"
      (buttonClick)="onMenuAction()"
    >
      Donate
    </ui-button>
  </div>
} @else {
  <div class="flex items-center gap-2">
    @if (showAccount) {
      <gb-header-account-menu
        mode="dropdown"
        [signInLabel]="signInLabel"
        [dashboardUrl]="dashboardUrl"
        (menuAction)="onMenuAction()"
      ></gb-header-account-menu>
    }

    <ui-button
      variant="primary"
      [outline]="true"
      ariaLabel="Create a fundraising page"
      (buttonClick)="fundraise()"
    >
      Fundraise
    </ui-button>

    <ui-button variant="primary" [routerLink]="AppRoutes.checkout.root()">Donate</ui-button>
  </div>
}
